import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LgvFormlyModel } from '../../../data-models/formly.model';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';

@Component({
    selector: 'lgv-section-summary',
    templateUrl: './section-summary.component.html',
    styleUrls: ['./section-summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionSummaryComponent implements OnInit {

    @Input() level1Param = -1;
    @Input() level2Param = -1;
    @Input() arrayIndex = null;
    @Input() showHeaderRow = true;
    @Input() summary: LgvFormlyModel.GroupSummary;
    @Input() sectionLabel: string;

    constructor(public lgvFormSvc: LgvFormUtilityService) { }


    ngOnInit(): void {
        // console.log(`======= section summary ${this.sectionLabel} ${this.level1Param} ${this.level2Param} . [${this.arrayIndex}] ==============`);
        // console.log(this.summary);
  }

    displayArrayObject(obj: any): string {

        let rtnVal = '';

        // console.log('=== displayArrayObject() ===');
        // console.log(obj);
        // console.log('=======');


        Object.keys(obj).forEach(k1 => {
            // console.log(k1);
            let thisVal = obj[k1];

            if (thisVal && thisVal !== '') {
                if (rtnVal.length > 0) {
                    rtnVal += '  |  ';
                }
                rtnVal += `${obj[k1]}`;
            }


        });

        return rtnVal;

    }

}
